/*
 * @Description: 
 * @Autor: wangwangwang
 * @Date: 2021-01-12 12:08:10
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-04-01 12:03:31
 */
import request from '@/utils/request'
export const queryPage = '/icps/system/sign/dataCollection/supplierPlanDetail/SupplierQueryPage'
/*修改或提交计划*/
export function updateStatus(data) {
  return request({
    url: '/icps/system/sign/dataCollection/supplierPlanDetail/updateStatus',
    method: 'post',
    data
  })
}
export function queryListsByPid(data) {
  return request({
    url: '/icps/system/sign/dataCollection/cooperation/queryListsByPid',
    method: 'post',
    data
  })
}
/*实际交货*/
export function consignment(data) {
  return request({
    url: '/icps/system/sign/dataCollection/consignment/save',
    method: 'post',
    data
  })
}
/*异常审核*/
export function abnormalAudit(data) {
  return request({
    url: '/icps/system/sign/dataCollection/consignment/abnormalAudit',
    method: 'post',
    data
  })
}
/*登录用户的供应商id*/
export function queryXinByUserid(data) {
  return request({
    url: '/icps/system/sign/dataCollection/contract/queryXinByUserid',
    method: 'post',
    data
  })
}
/*登录用户的供应商id*/
export function supplierQueryPage(data) {
  return request({
    url: '/icps/system/sign/dataCollection/supplier/QueryPage',
    method: 'post',
    data
  })
}
/*登录用户的供应商id*/
export function CalculationAmountByCooperationId(data) {
  return request({
    url: '/icps/system/sign/dataCollection/cooperation/CalculationAmountByCooperationId',
    method: 'post',
    data
  })
}